// Откъде идва потребителят (за колоната „Източник“ в админа).
//
// Уеб: при зареждане четем utm_* (и от „#check?utm_source=…“ — Facebook
// понякога лепи параметрите след фрагмента), fbclid/gclid и document.referrer.
// Пазим ПЪРВИЯ смислен източник 30 дни — човек често идва от реклама, а се
// регистрира при второ отваряне. На телефон източникът е самото приложение.
// Изпраща се само при регистрация, като кратък текст без лични данни.

import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

const KEY = 'livupp.source';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

type Stored = { label: string; direct: boolean; ts: number };

function hostOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '').replace(/^(m|l|lm)\./, '');
  } catch {
    return '';
  }
}

// „facebook / cpc / proverka · #check“
function detectWeb(): Stored {
  const loc = window.location;
  const hash = loc.hash || '';
  const [hashPath, hashQuery = ''] = hash.split('?');
  const params = new URLSearchParams(`${loc.search.replace(/^\?/, '')}&${hashQuery}`);
  const landing = hashPath && hashPath !== '#' ? ` · ${hashPath.slice(0, 30)}` : '';
  const clean = (v: string | null) => (v ?? '').trim().slice(0, 40);

  const utmSource = clean(params.get('utm_source'));
  if (utmSource) {
    const parts = [utmSource, clean(params.get('utm_medium')), clean(params.get('utm_campaign'))].filter(Boolean);
    return { label: `${parts.join(' / ')}${landing}`, direct: false, ts: Date.now() };
  }
  if (params.get('fbclid')) return { label: `facebook / линк${landing}`, direct: false, ts: Date.now() };
  if (params.get('gclid')) return { label: `google / реклама${landing}`, direct: false, ts: Date.now() };

  const ref = typeof document !== 'undefined' ? hostOf(document.referrer) : '';
  if (ref && ref !== loc.hostname.replace(/^www\./, '')) {
    let name = ref;
    if (/facebook\.com$|fb\.com$/.test(ref)) name = 'facebook';
    else if (/instagram\.com$/.test(ref)) name = 'instagram';
    else if (/google\./.test(ref)) name = 'google / търсене';
    else if (/livupp\.com$/.test(ref)) name = 'сайта livupp.com';
    return { label: `${name}${landing}`, direct: false, ts: Date.now() };
  }
  return { label: `директно${landing}`, direct: true, ts: Date.now() };
}

// Извиква се веднъж при старт.
export async function captureSource(): Promise<void> {
  try {
    const now: Stored =
      Platform.OS === 'web' && typeof window !== 'undefined'
        ? detectWeb()
        : { label: Platform.OS === 'ios' ? 'приложение iOS' : 'приложение Android', direct: true, ts: Date.now() };
    const raw = await AsyncStorage.getItem(KEY);
    const old: Stored | null = raw ? JSON.parse(raw) : null;
    const fresh = old && Date.now() - old.ts < TTL_MS;
    // пазим първия НЕдиректен източник; директен не го презаписва
    if (!fresh || (old.direct && !now.direct)) {
      await AsyncStorage.setItem(KEY, JSON.stringify(now));
    }
  } catch {
    /* без памет — ще се определи при регистрация */
  }
}

// Кратък етикет за регистрацията (макс. 120 знака) или undefined.
export async function getSignupSource(): Promise<string | undefined> {
  try {
    const raw = await AsyncStorage.getItem(KEY);
    if (raw) {
      const s: Stored = JSON.parse(raw);
      if (s?.label) return String(s.label).slice(0, 120);
    }
  } catch {
    /* пада към текущото */
  }
  if (Platform.OS === 'web' && typeof window !== 'undefined') return detectWeb().label.slice(0, 120);
  return Platform.OS === 'ios' ? 'приложение iOS' : 'приложение Android';
}
